module.exports = __webpack_public_path__ + "img/faq5.6cd805aa.png";